import { useApolloPaging } from 'hooks';
import { useCallback } from 'react';
import { SCHEDULING_TIME_OFF_QUERY } from '../apollo/scheduling-queries';
import { SchedulingTimeOff } from '../types/types';
import { shouldShowSchedulingTimeOffs } from '../utils/utils';
import useSchedulingQueryParams from './useSchedulingQueryParams';
import { useSchedulingTimeOffVariables } from './useSchedulingTimeOffVariables';

export default function useSchedulingTimeOffQuery() {
  const { getAll } = useApolloPaging();
  const variables = useSchedulingTimeOffVariables();
  const schedulingQueryParams = useSchedulingQueryParams();

  return useCallback(async () => {
    if (!shouldShowSchedulingTimeOffs(schedulingQueryParams)) {
      return [];
    }

    return getAll<SchedulingTimeOff>('timeOffs', {
      query: SCHEDULING_TIME_OFF_QUERY,
      variables,
      fetchPolicy: 'network-only',
    });
  }, [getAll, schedulingQueryParams, variables]);
}
